import React from 'react';
import { Tooltip as AntTooltip, TooltipProps as AntTooltipProps } from 'antd';
import { createUseStyles } from 'react-jss';
import { ThemeType } from 'src/theming/jssTypes';

export type TooltipProps = AntTooltipProps & {
  className?: string;
};

const useStyles = createUseStyles((theme: ThemeType) => ({
  tooltip: {
    '& .ant-tooltip-inner': {
      backgroundColor: theme.color.semantic.background.neutral.inverse,
      color: theme.color.semantic.text.inverse,
      padding: theme.spacing[2],
      borderRadius: theme.radius.sm,
      boxShadow: theme.shadow.md,
    },
    '& .ant-tooltip-arrow-content': {
      backgroundColor: theme.color.semantic.background.neutral.inverse,
    },
  },
}));

const Tooltip: React.FC<TooltipProps> = ({ className = '', overlayClassName = '', ...rest }) => {
  const classes = useStyles();
  return (
    <AntTooltip
      {...rest}
      overlayClassName={`${classes.tooltip} ${overlayClassName}`.trim()}
      className={className}
    />
  );
};

export default Tooltip;
